$(function() {
    const Accordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        const links = this.el.find('.link')
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
        const $el = e.data.el
        const $this = $(this)
        const $next = $this.next()

        $next.slideToggle()
        $this.parent().toggleClass('open')

        if (!e.data.multiple)
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open')
    }

    var accordion = new Accordion($('#accordion'), false);
});
